import styled from "styled-components";

export const InputArea = styled.input`
  border-radius: 4px;
  border: solid 1px #58c9df;
  height: 31px;
  width: 80%;
  padding: 0 10px;
  margin-bottom: 10px;
  &:focus {
    border-bottom: none;
  }
`;

export const LoginPageButton = styled.button`
  width: 112px;
  height: 33px;
  border-radius: 4px;
  background-color: #53d2dc;
  margin-top: 20px;
  border: solid 1px #53d2dc;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  padding: 8px;
`;

export const Container = styled.div`
  width: 60%;
  margin: 0 auto;
  padding: 100px 0;
  text-align: -webkit-center;
  height: 650px;
  font-family: Verdana;
  display: flex;
  flex-direction: column;
  align-items: left;
  // @media only screen and (min-width: 993px) {
  //   width: 70%;
  // }
  // @media only screen and (min-width: 601px) {
  //   width: 85%;
  // }
`;

export const Title = styled.div`
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  color: #000000;
`;

export const Description = styled.div`
  margin: 14px 0;
  font-size: 12px;
  color: #8f8f8f;
`;
